import { useParams } from "react-router-dom";

function ModifyProduct() {
    const params = useParams();

    return <h1>Modificazione prodotto :: {params.id}</h1>
}

export default ModifyProduct;